import script from "./TrainerGameInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerGameInvite.vue?vue&type=script&setup=true&lang=js"

import "./TrainerGameInvite.vue?vue&type=style&index=0&id=322177d6&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322177d6"]])

export default __exports__